<div class="container-fluid login-two-container">
  <div class="row main-login-two">
    <div class="col-xl-6 col-lg-6 col-md-6 d-none d-md-block p-0">
      <div class="login-bg">
        <div class="left-content-area">
          <div class="card-content">
            <h2>{{ 'login.bannerText1' | translate }}</h2>
            <p>{{ 'login.bannerText2' | translate }}</p>
            <a
              class="btn mt-4 btn-login-info"
              href="https://safecloudsinglar.com/"
              target="_blank"
              type="button"
            >
              {{ 'login.bannerText3' | translate }}
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-6 col-lg-6 col-md-6 p-0">
      <div class="login-two-start">
        <div
          class="d-flex flex-column align-items-center justify-content-center"
          style="flex-grow: 1"
        >
          <div class="logo-container">
            <img
              class="logo-safecloud-1"
              src="../../assets/img/safecloud-1.png"
              alt="logo"
            />
          </div>
          <div style="width: 100%" *ngIf="!newCompanyCreated">
            <h6
              class="right-bar-heading px-3 mt-2 mb-4 text-dark text-center font-30"
            >
              {{ 'createEnterprise.title' | translate }}
            </h6>

            <form
              [formGroup]="createCompanyForm"
              style="width: 80%; margin: 0 auto"
            >
              <div class="login-two-inputs mt-4 input-group">
                <input
                  type="text"
                  class="form-control"
                  [placeholder]="'createEnterprise.idPlaceholder' | translate"
                  formControlName="SubscriptionId"
                  style="background-color: #e9ecef"
                  required
                />
                <i class="las la-id-card"></i>
              </div>

              <div class="login-two-inputs mt-4 input-group">
                <input
                  type="text"
                  class="form-control"
                  [placeholder]="
                    'createEnterprise.companyNamePlaceholder' | translate
                  "
                  formControlName="CompanyName"
                  [ngClass]="{
                    'is-invalid':
                      createCompanyForm.get('CompanyName').invalid &&
                      createCompanyForm.get('CompanyName').touched
                  }"
                  required
                />
                <i class="las la-building"></i>
                <div
                  class="invalid-feedback"
                  *ngIf="
                    createCompanyForm.get('CompanyName').errors?.required &&
                    createCompanyForm.get('CompanyName').touched
                  "
                >
                  {{ 'createEnterprise.nameRequired' | translate }}
                </div>
              </div>

              <div class="login-two-inputs mt-4 input-group">
                <input
                  type="text"
                  class="form-control"
                  [placeholder]="
                    'createEnterprise.addressPlaceholder' | translate
                  "
                  formControlName="Address"
                  [ngClass]="{
                    'is-invalid':
                      createCompanyForm.get('Address').invalid &&
                      createCompanyForm.get('Address').touched
                  }"
                  required
                />
                <i class="las la-map-marker-alt"></i>
                <div
                  class="invalid-feedback"
                  *ngIf="
                    createCompanyForm.get('Address').errors?.required &&
                    createCompanyForm.get('Address').touched
                  "
                >
                  {{ 'createEnterprise.addressRequired' | translate }}
                </div>
              </div>

              <div class="login-two-inputs mt-4 input-group">
                <input
                  type="text"
                  class="form-control"
                  [placeholder]="
                    'createEnterprise.phonePlaceholder' | translate
                  "
                  formControlName="Phone"
                  [ngClass]="{
                    'is-invalid':
                      createCompanyForm.get('Phone').invalid &&
                      createCompanyForm.get('Phone').touched
                  }"
                  required
                />
                <i class="las la-phone"></i>
                <div
                  class="invalid-feedback"
                  *ngIf="
                    createCompanyForm.get('Phone').errors?.required &&
                    createCompanyForm.get('Phone').touched
                  "
                >
                  {{ 'createEnterprise.phoneRequired' | translate }}
                </div>
                <div
                  class="invalid-feedback"
                  *ngIf="
                    createCompanyForm.get('Phone').errors?.pattern &&
                    createCompanyForm.get('Phone').touched
                  "
                >
                  {{ 'createEnterprise.onlyNumbers' | translate }}
                </div>
              </div>

              <div class="login-two-inputs mt-4 input-group">
                <input
                  type="email"
                  class="form-control"
                  [placeholder]="
                    'createEnterprise.emailPlaceholder' | translate
                  "
                  formControlName="Email"
                  [ngClass]="{
                    'is-invalid':
                      createCompanyForm.get('Email').invalid &&
                      createCompanyForm.get('Email').touched
                  }"
                  required
                />
                <i class="las la-envelope"></i>
                <div
                  class="invalid-feedback"
                  *ngIf="
                    createCompanyForm.get('Email').errors?.required &&
                    createCompanyForm.get('Email').touched
                  "
                >
                  {{ 'createEnterprise.emailRequired' | translate }}
                </div>
                <div
                  class="invalid-feedback"
                  *ngIf="
                    createCompanyForm.get('Email').errors?.email &&
                    createCompanyForm.get('Email').touched
                  "
                >
                  {{ 'createEnterprise.invalidEmail' | translate }}
                </div>
              </div>

              <div class="login-two-inputs mt-5 text-center d-flex">
                <button
                  style="max-height: 40px"
                  class="ripple-button ripple-button-primary btn-login ml-3 mr-3"
                  (click)="createCompany()"
                  [disabled]="isLoading || createCompanyForm.invalid"
                  [ngStyle]="
                    createCompanyForm.invalid
                      ? {
                          'background-color': '#ccc',
                          color: '#fff',
                          'text-shadow': 'none'
                        }
                      : {}
                  "
                >
                  <div class="ripple-ripple js-ripple">
                    <span class="ripple-ripple__circle"></span>
                  </div>
                  <span *ngIf="!isLoading">{{
                    'createEnterprise.title' | translate
                  }}</span>

                  <div
                    style="position: relative; top: -5px"
                    class="d-flex justify-content-center loader"
                    *ngIf="isLoading"
                  >
                    <div class="spinner-border" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>
                </button>
              </div>
            </form>
          </div>
          <div class="new-company-created-container" *ngIf="newCompanyCreated">
            <i class="las la-check-circle success-icon"></i>
            <div class="new-company-created-title">
              <h4>{{ 'createEnterprise.success' | translate }}</h4>
              <span>
                {{
                  'createEnterprise.nameCreated'
                    | translate
                      : { name: createCompanyForm.get('CompanyName').value }
                }}
              </span>
            </div>
            <div class="new-company-details">
              <div class="new-company-details-item">
                <span>{{ 'createEnterprise.idSubscription' | translate }}</span>
                <span>{{ createCompanyForm.get('SubscriptionId').value }}</span>
              </div>
              <hr class="hr-new-company" />
              <div class="new-company-details-item">
                <span>{{ 'createEnterprise.companyName' | translate }}</span>
                <span>{{ createCompanyForm.get('CompanyName').value }}</span>
              </div>
              <hr class="hr-new-company" />
              <div class="new-company-details-item">
                <span>{{ 'createEnterprise.companyEmail' | translate }}</span>
                <span>{{ createCompanyForm.get('Email').value }}</span>
              </div>
              <hr class="hr-new-company" />
              <div class="new-company-details-item">
                <span>{{ 'createEnterprise.companyPhone' | translate }}</span>
                <span>{{ createCompanyForm.get('Phone').value }}</span>
              </div>
            </div>
            <div class="next-steps">
              <div>
                <i class="las la-shield-alt badge-icon"></i>
              </div>
              <div>
                <h6>{{ 'createEnterprise.nextStepsTitle' | translate }}</h6>
                <span>{{
                  'createEnterprise.nextStepsDescription' | translate
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
